import { USERS_MANAGEMENT_PATH } from 'routing/routes/users/constants';
export var USERS_ROLES_LIST_PATH = "".concat(USERS_MANAGEMENT_PATH, "roles");
export var USERS_ROLES_DETAILS_PATH = "".concat(USERS_ROLES_LIST_PATH, "/:id");
export var USERS_ROLES_USERS_PATH = "".concat(USERS_ROLES_DETAILS_PATH, "/users");
export var getRoleDetailsPath = function getRoleDetailsPath(id) {
    return "".concat(USERS_ROLES_LIST_PATH, "/").concat(id);
};
export var getRoleUsersPath = function getRoleUsersPath(id) {
    return "".concat(getRoleDetailsPath(id), "/users");
};
